import { createContext, useContext, FC, ReactNode } from 'react';
import { Price } from 'shared-types';

export interface CurrentStepContextValue {
  packageTotalPrice: Price;
  isSubmitting: boolean;
  addToBasket: () => void;
  hash: string;
  itinerary?: {
    label: string;
    onOpen: () => void;
  };
}

const CurrentStepContext = createContext<CurrentStepContextValue | undefined>(undefined);

export interface CurrentStepProviderProps {
  value: CurrentStepContextValue;
  children: ReactNode;
}

export const CurrentStepProvider: FC<CurrentStepProviderProps> = ({ value, children }) => {
  return <CurrentStepContext.Provider value={value}>{children}</CurrentStepContext.Provider>;
};

export const useCurrentStep = (): CurrentStepContextValue => {
  const context = useContext(CurrentStepContext);
  if (context === undefined) {
    throw new Error('useCurrentStep must be used within a CurrentStepProvider');
  }
  return context;
};
